import StudentLanguageProficiency from "./src/main";
/* istanbul ignore next */
StudentLanguageProficiency.install = function (Vue) {
  Vue.component(StudentLanguageProficiency.name, StudentLanguageProficiency);
};

export default StudentLanguageProficiency;
